import { render } from "./TorpedoBoard.vue?vue&type=template&id=970b4de0"
import script from "./TorpedoBoard.vue?vue&type=script&lang=js"
export * from "./TorpedoBoard.vue?vue&type=script&lang=js"

import "./TorpedoBoard.vue?vue&type=style&index=0&id=970b4de0&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__